import React from 'react';
import '../styles/pages/Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Top 10 Wedding Card Designs for 2024",
      date: "January 15, 2024",
      author: "Deepak Chaurasiya",
      category: "Wedding Cards",
      excerpt: "Discover the latest trends in wedding card designs, from traditional motifs to modern minimalist styles that are making waves this year.",
      image: "https://images.unsplash.com/photo-1519744346360-e79a5a4b4aaa?w=600",
      readTime: "5 min read"
    },
    {
      id: 2,
      title: "Flex Printing vs Vinyl Printing: Which is Better?",
      date: "January 10, 2024",
      author: "Gyaniraj Team",
      category: "Printing Technology",
      excerpt: "Learn the key differences between flex printing and vinyl printing, their applications, and which option suits your specific needs best.",
      image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600",
      readTime: "7 min read"
    },
    {
      id: 3,
      title: "Creative Visiting Card Ideas for Small Businesses",
      date: "January 5, 2024",
      author: "Design Team",
      category: "Business Cards",
      excerpt: "Explore innovative visiting card designs that help small businesses make a lasting impression on potential clients and partners.",
      image: "https://images.unsplash.com/photo-1566125882500-87e10f726cdc?w=600",
      readTime: "6 min read"
    },
    {
      id: 4,
      title: "LED Signage: The Future of Business Advertising",
      date: "December 28, 2023",
      author: "Deepak Chaurasiya",
      category: "Signage",
      excerpt: "Understand how LED signage is revolutionizing business advertising with energy efficiency, durability, and eye-catching displays.",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600",
      readTime: "8 min read"
    },
    {
      id: 5,
      title: "Eco-Friendly Printing Solutions: Going Green",
      date: "December 20, 2023",
      author: "Gyaniraj Team",
      category: "Sustainability",
      excerpt: "Discover sustainable printing practices and eco-friendly materials that reduce environmental impact while maintaining quality.",
      image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600",
      readTime: "5 min read"
    },
    {
      id: 6,
      title: "Choosing the Right Paper for Your Printing Needs",
      date: "December 15, 2023",
      author: "Printing Expert",
      category: "Printing Tips",
      excerpt: "A comprehensive guide to selecting the perfect paper type for different printing projects, from business cards to large banners.",
      image: "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=600",
      readTime: "6 min read"
    }
  ];

  const categories = [
    "All",
    "Wedding Cards",
    "Printing Technology",
    "Business Cards",
    "Signage",
    "Sustainability",
    "Printing Tips"
  ];

  return (
    <div className="blog-page">
      <div className="blog-hero">
        <div className="container">
          <h1>Printing Insights & Tips</h1>
          <p>Stay updated with the latest trends, tips, and insights from Gyaniraj Offset</p>
        </div>
      </div>

      <div className="blog-content">
        <div className="container">
          <section className="blog-header">
            <div className="blog-stats">
              <span>{blogPosts.length} Articles</span>
              <span>•</span>
              <span>Updated Weekly</span>
            </div>
            <div className="category-filter">
              {categories.map((category) => (
                <button key={category} className="category-btn">
                  {category}
                </button>
              ))}
            </div>
          </section>

          <section className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-image">
                  <img src={post.image} alt={post.title} />
                  <span className="category-tag">{post.category}</span>
                </div>
                <div className="blog-content-card">
                  <div className="blog-meta">
                    <span className="date">{post.date}</span>
                    <span className="read-time">{post.readTime}</span>
                  </div>
                  <h3 className="blog-title">{post.title}</h3>
                  <p className="blog-excerpt">{post.excerpt}</p>
                  <div className="blog-footer">
                    <span className="author">By {post.author}</span>
                    <button className="read-more-btn">Read More</button>
                  </div>
                </div>
              </article>
            ))}
          </section>

          <section className="newsletter-section">
            <div className="newsletter-card">
              <h3>Stay Updated</h3>
              <p>Subscribe to our newsletter for the latest printing tips and industry insights</p>
              <form className="newsletter-form">
                <input type="email" placeholder="Enter your email" required />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Blog;
